export default {
  cards: {
    buttonShort: "Download",
    carbonButtonLong: "Download all certificates",
    carbonTitle: "Certificates",
    energyButtonLong: "Download all EU EPC ratings",
    energyTitle: "EU EPC rating certificates",
    noCertificate: "No additional certifications are available!",
  },
  chart: {
    bronze: "DGNB-building in use-Bronze",
    carbonTitle: "Certification status by floor area",
    energyTitle: "Energy rating by floor area",
    gold: "DGNB-building in use-Gold",
    notCertified: "Not certified",
    platinum: "DGNB-building in use-Platinum",
    silver: "DGNB-building in use-silver",
  },
};
